// extracted by mini-css-extract-plugin
module.exports = {"CommentsButton":"iy_a bhe_vr bhe_iv bhe_wf bhe_i bhe_j bhe_q bhe_un bhe_en bhe_ri bhe_rj bhe_cx","CommentsButton__icon":"iy_b bhe_re"};